import type { Directive } from "vue";
import { gsap } from "gsap";
const tls: any[] = [];
const play = (paused: boolean, duration: number, el: (HTMLElement | Node) & { tl?: any }) => {
    function scroll(element: HTMLElement | Node, time: number, paused: boolean) {
        return gsap.fromTo(
            element,
            {
                x: 0,
            },
            {
                x: "-100%",
                duration: time,
                ease: "linear",
                repeat: -1,
                paused: paused,
            }
        );
    }
    const tl = scroll(el, duration, paused);
    el.tl = tl;
    tls.push(tl);
};

const start = () => {
    tls.forEach((tl) => tl.paused(!tl.paused()));
};

const stop = () => {
    tls.forEach((tl) => tl.paused(!tl.paused()));
};

export const vLoopScroll: Directive = {
    mounted(el: HTMLElement & { tl?: any }, binding) {
        // 复制一个节点并追加
        const copyEl = el.cloneNode(true);
        el.parentNode!.appendChild(copyEl);
        // 第一个节点和第二个节点同时播放
        play(false, binding.value, el);
        play(false, binding.value, copyEl);
        const parent: HTMLElement | undefined | null = el.parentNode?.parentElement;
        parent!.onmouseleave = start;
        parent!.onmouseenter = stop;
        parent!.ontouchend = start;
        parent!.ontouchstart = stop;
    },
    beforeUnmount(el: HTMLElement & { tl?: any }) {
        const index = tls.findIndex((item) => item === el.tl);
        tls.splice(index, 1);
    },
};
